import React from "react";

import { Icon, IconProps } from "../";

export const SupportedBoldIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 1.5 13.14 1.5 9ZM3.5 9C3.5 12.0319 5.96813 14.5 9 14.5C12.0319 14.5 14.5 12.0319 14.5 9C14.5 5.96813 12.0319 3.5 9 3.5C5.96813 3.5 3.5 5.96813 3.5 9Z"
        />
      </g>
    </Icon>
  );
};
